import { css } from "@emotion/react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAtom } from "jotai";
import React from "react";

import { loadingAtom } from "@/global-state/jotai-atom";

type Props = {
  children: React.ReactNode;
  open?: boolean;
};

export const BackdropProgress: React.FC<Props> = (props) => {
  const [loading] = useAtom(loadingAtom);
  return (
    <>
      <Backdrop css={backdropStyles} open={props.open || loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {props.children}
    </>
  );
};

const backdropStyles = css`
  z-index: 9999 !important;
  color: #ffffff;
  position: fixed;
`;
